import auth from './auth';
import customer from './customer';
import toggle from './toggle';

export default {
  auth,
  customer,
  toggle,
};
